module.exports = __webpack_public_path__ + "assets/img/solar-panels-6-small.3ab462d0.jpg";